import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetAllParametric, GetAllParametricActivities, GetAllParametricDocumentSector, GetAllParametricLeyendas, GetAllParametricProductService, GetPointsOfSale, TypeParametric } from './interfaces/parametric.interface';
import { sId } from '../shared/interfaces/api.interfaces';
const base_url = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class ParametricService {
  private http = inject(HttpClient);

  getParametric(type: TypeParametric): Observable<GetAllParametric[]> {
    const url = `${base_url}/parametric/${type}`;
    return this.http.get<GetAllParametric[]>(url);
  }

  getParametricActivities(): Observable<GetAllParametricActivities[]> {
    const url = `${base_url}/parametric/activities`;
    return this.http.get<GetAllParametricActivities[]>(url);
  }

  getParametricProductService(): Observable<GetAllParametricProductService[]> {
    const url = `${base_url}/parametric/productService`;
    return this.http.get<GetAllParametricProductService[]>(url);
  }

  getParametricLeyendas(): Observable<GetAllParametricLeyendas[]> {
    const url = `${base_url}/parametric/legends`;
    return this.http.get<GetAllParametricLeyendas[]>(url);
  }

  getParametricDocumentSector(): Observable<GetAllParametricDocumentSector[]> {
    const url = `${base_url}/parametric/activityDocumentSector`;
    return this.http.get<GetAllParametricDocumentSector[]>(url);
  }

  synchronizationActivities() {
    const url = `${base_url}/synchronization/activity`;
    return this.http.get(url);
  }

  synchronizationDocumentSector() {
    const url = `${base_url}/synchronization/activityDocumentSector`;
    return this.http.get(url);
  }

  synchronizationLeyendas() {
    const url = `${base_url}/synchronization/legends`;
    return this.http.get(url);
  }

  synchronizationProductService() {
    const url = `${base_url}/synchronization/productService`;
    return this.http.get(url);
  }

  getPointsOfSale(branchId: sId): Observable<GetPointsOfSale[]> {
    const url = `${base_url}/pointOfSale/select/${branchId}`;
    return this.http.get<GetPointsOfSale[]>(url);
  }
}
